import { getPremiumEssentialsSafe } from '@wix/premium-fed-sdk/@premium-essentials';
import { ExperimentSpecs } from '../constants';
import { useQueryParams } from './useQueryParams';
export const useIsMailboxIntent = () => {
  const {
    getQueryParam
  } = useQueryParams();
  return getQueryParam('referralInfo') === 'my-mailboxes-site-level' || getQueryParam('referralAdditionalInfo') === 'my-mailboxes-account-level';
};
export const useIsMailboxReferralBM = () => {
  var _getPremiumEssentials;
  const isMailboxIntent = useIsMailboxIntent();
  const isSpecOn = Boolean((_getPremiumEssentials = getPremiumEssentialsSafe()) == null || (_getPremiumEssentials = _getPremiumEssentials.experiments) == null ? void 0 : _getPremiumEssentials[ExperimentSpecs.MailboxReferralBM]);
  return isSpecOn && isMailboxIntent;
};
//# sourceMappingURL=useIsMailboxReferral.js.map